import React from "react";

const Content = () => {
  return (
    <div className="h-full mb-20">
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/bubble-38.png"
        alt=""
        className="absolute  -z-10 right-16"
      />
      <img
        src="https://new.axilthemes.com/demo/react/abstrak/images/others/line-4.png"
        alt=""
        className="absolute -z-10 mt-30"
      />
      <div className="flex items-center flex-col p-5">
        <h1 className="text-5xl mb-4 font-bold font-dmsans">
          Our templates are just ready to use
        </h1>
        <p className="text-xl text-gray-500">
          You will love all of the features in our Template. 100% guaranteed
          satisfaction.
        </p>
      </div>
      <div className="flex gap-10 justify-center flex-col items-center p-5">
        <div className="group  flex flex-col items-center cursor-pointer">
          <div className="h-200 overflow-hidden mt-10 rounded-3xl w-200 bg-white">
            <img
              src="https://new.axilthemes.com/demo/react/abstrak/images/others/demo-1.png"
              className="w-full h-full group-hover:scale-120 transition-all duration-500 "
              alt=""
            />
          </div>
          <h1 className=" ml-16 mt-5 text-3xl group-hover:text-[#5956e9]   transition text-black">
            coming soon
          </h1>
        </div>
        <div className="group  flex flex-col items-center cursor-pointer">
          <div className="h-200 overflow-hidden mt-10 rounded-3xl w-200 bg-white">
            <img
              src="https://new.axilthemes.com/demo/react/abstrak/images/others/demo-2.png"
              className="w-full h-full group-hover:scale-120 transition-all duration-500 "
              alt=""
            />
          </div>
          <h1 className=" ml-16 text-3xl mt-5 group-hover:text-[#5956e9]   transition text-black">
            coming soon
          </h1>
        </div>
      </div>
      <div className="flex gap-10 justify-center flex-col items-center p-5">
        <div className="group  flex flex-col items-center cursor-pointer">
          <div className="h-200 overflow-hidden mt-10 rounded-3xl w-200 bg-white">
            <img
              src="https://new.axilthemes.com/demo/react/abstrak/images/others/demo-1.png"
              className="w-full h-full group-hover:scale-120 transition-all duration-500 "
              alt=""
            />
          </div>
          <h1 className=" ml-16 text-3xl mt-5 group-hover:text-[#5956e9] transition text-black">
            coming soon
          </h1>
        </div>
        <div className="group  flex flex-col items-center cursor-pointer">
          <div className="h-200 overflow-hidden mt-10 rounded-3xl w-200 bg-white">
            <img
              src="https://new.axilthemes.com/demo/react/abstrak/images/others/demo-2.png"
              className="w-full h-full group-hover:scale-120 transition-all duration-500 "
              alt=""
            />
          </div>
          <h1 className=" ml-16 text-3xl mt-5 group-hover:text-[#5956e9]   transition text-black">
            coming soon
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Content;
